// extracted by mini-css-extract-plugin
export default {"container":"ModalHeader_container__gVLMj","title":"ModalHeader_title__7YP62","close":"ModalHeader_close__NrqB-"};